import { render, staticRenderFns } from "./DefaultSort.vue?vue&type=template&id=5d9d56f8&scoped=true&"
import script from "./DefaultSort.vue?vue&type=script&lang=js&"
export * from "./DefaultSort.vue?vue&type=script&lang=js&"
import style0 from "./DefaultSort.vue?vue&type=style&index=0&id=5d9d56f8&prod&lang=css&"
import style1 from "./DefaultSort.vue?vue&type=style&index=1&id=5d9d56f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d56f8",
  null
  
)

export default component.exports